import ReactOnRails from 'react-on-rails'
import { FunctionComponent } from 'react'

import { AppEntryPoint } from 'packs/main-app-entry/AppEntryPoint'

ReactOnRails.register({
  AppEntryPoint: AppEntryPoint as FunctionComponent,
})
